import { colors } from '../constants';
const styleOverrides = {
  root: ({
    ownerState
  }) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: colors.oriGrey.A100,
    ...(ownerState.color === 'inherit' && {
      '&::before': {
        backgroundColor: colors.oriGrey.A100
      }
    })
  }),
  bar: {
    borderRadius: 4
  },
  dashed: {
    backgroundSize: '10.8px 10.8px'
  },
  bar2Buffer: {
    opacity: 0.3
  },
  barColorPrimary: {
    backgroundColor: colors.error.light
  },
  dashedColorPrimary: {
    backgroundImage: `radial-gradient(${colors.error.light} 0%, ${colors.error.light} 16%, transparent 42%)`
  },
  barColorSecondary: {
    backgroundColor: colors.success.light
  },
  dashedColorSecondary: {
    backgroundImage: `radial-gradient(${colors.success.light} 0%, ${colors.success.light} 16%, transparent 42%)`
  }
};
export default {
  styleOverrides
};